import React from 'react'
import Modal from './Modal'

interface ConfirmDialogProps {
  title?: string
  message: string
  onConfirm: () => void
  onCancel: () => void
  confirmText?: string
  cancelText?: string
  confirmButtonClass?: string
}

export default function ConfirmDialog({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  confirmButtonClass = 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700'
}: ConfirmDialogProps) {
  return (
    <Modal isOpen={true} onClose={onCancel} size="md" showCloseButton={false} className="z-[60]">
      <div className="p-6">
        {title && <h2 className="text-xl font-bold text-gray-900 mb-3">{title}</h2>}
        <p className={`text-gray-700 ${title ? 'mb-6' : 'mb-6 text-lg'}`}>{message}</p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 transition-all"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 px-6 py-3 text-white font-semibold rounded-lg transition-all shadow-lg ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
